import { render, staticRenderFns } from "./OrariCompany.vue?vue&type=template&id=99b764a4&"
import script from "./OrariCompany.vue?vue&type=script&lang=js&"
export * from "./OrariCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports